import * as Types from '../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SpotForPreviewSidebarFragment = { __typename?: 'Spot', id: string, assetId: number, courseId: string, spotType: Types.SpotType, name?: string | null, description?: string | null, order: number, parentSpotId?: string | null, note?: string | null, narrationText?: string | null, hasRestroom: boolean, hasRestaurant: boolean, hasCafe: boolean, hasFreeParking: boolean, hasPaidParking: boolean, hasMusic: boolean, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } };

export type FetchCourseQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type FetchCourseQuery = { __typename?: 'QueryRoot', course: { __typename?: 'Course', id: string, name: string, isVisibleToAllUserGroups: boolean, spots: Array<{ __typename?: 'Spot', id: string, assetId: number, courseId: string, spotType: Types.SpotType, name?: string | null, description?: string | null, order: number, parentSpotId?: string | null, note?: string | null, narrationText?: string | null, hasRestroom: boolean, hasRestaurant: boolean, hasCafe: boolean, hasFreeParking: boolean, hasPaidParking: boolean, hasMusic: boolean, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } }> } };

export type RoutingInfomationQueryVariables = Types.Exact<{
  courseId: Types.Scalars['String'];
}>;


export type RoutingInfomationQuery = { __typename?: 'QueryRoot', routingInfomation: { __typename?: 'RoutingInfomationPayload', error?: string | null, routingInfomation?: { __typename?: 'RoutingInfomation', from: { __typename?: 'Coordinate', lon: number, lat: number }, to: { __typename?: 'Coordinate', lon: number, lat: number }, route: Array<{ __typename?: 'Coordinate', lon: number, lat: number }>, navigation: Array<{ __typename?: 'NavigationVoiceAndCoordinate', navigationVoice: string, coordinate: { __typename?: 'Coordinate', lon: number, lat: number } }>, spotStat: Array<{ __typename?: 'SpotStat', statsAfterSpotId: string, durationDistance: { __typename?: 'DurationDistance', duration: number, distance: number } }> } | null, routingInfomationWithoutOpt?: { __typename?: 'RoutingInfomation', from: { __typename?: 'Coordinate', lon: number, lat: number }, to: { __typename?: 'Coordinate', lon: number, lat: number }, route: Array<{ __typename?: 'Coordinate', lon: number, lat: number }>, navigation: Array<{ __typename?: 'NavigationVoiceAndCoordinate', navigationVoice: string, coordinate: { __typename?: 'Coordinate', lon: number, lat: number } }>, spotStat: Array<{ __typename?: 'SpotStat', statsAfterSpotId: string, durationDistance: { __typename?: 'DurationDistance', duration: number, distance: number } }> } | null } };

export const SpotForPreviewSidebarFragmentDoc = gql`
    fragment SpotForPreviewSidebar on Spot {
  id
  assetId
  courseId
  spotType
  name
  coordinate {
    lat
    lon
  }
  description
  order
  parentSpotId
  note
  narrationText
  hasRestroom
  hasRestaurant
  hasCafe
  hasFreeParking
  hasPaidParking
  hasMusic
}
    `;
export const FetchCourseDocument = gql`
    query FetchCourse($id: String!) {
  course(id: $id) {
    id
    name
    spots {
      ...SpotForPreviewSidebar
    }
    isVisibleToAllUserGroups
  }
}
    ${SpotForPreviewSidebarFragmentDoc}`;

export function useFetchCourseQuery(options: Omit<Urql.UseQueryArgs<FetchCourseQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchCourseQuery, FetchCourseQueryVariables>({ query: FetchCourseDocument, ...options });
};
export const RoutingInfomationDocument = gql`
    query RoutingInfomation($courseId: String!) {
  routingInfomation(courseId: $courseId) {
    routingInfomation {
      from {
        lon
        lat
      }
      to {
        lon
        lat
      }
      route {
        lon
        lat
      }
      navigation {
        coordinate {
          lon
          lat
        }
        navigationVoice
      }
      spotStat {
        statsAfterSpotId
        durationDistance {
          duration
          distance
        }
      }
    }
    routingInfomationWithoutOpt {
      from {
        lon
        lat
      }
      to {
        lon
        lat
      }
      route {
        lon
        lat
      }
      navigation {
        coordinate {
          lon
          lat
        }
        navigationVoice
      }
      spotStat {
        statsAfterSpotId
        durationDistance {
          duration
          distance
        }
      }
    }
    error
  }
}
    `;

export function useRoutingInfomationQuery(options: Omit<Urql.UseQueryArgs<RoutingInfomationQueryVariables>, 'query'>) {
  return Urql.useQuery<RoutingInfomationQuery, RoutingInfomationQueryVariables>({ query: RoutingInfomationDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFetchCourseQuery((req, res, ctx) => {
 *   const { id } = req.variables;
 *   return res(
 *     ctx.data({ course })
 *   )
 * })
 */
export const mockFetchCourseQuery = (resolver: ResponseResolver<GraphQLRequest<FetchCourseQueryVariables>, GraphQLContext<FetchCourseQuery>, any>) =>
  graphql.query<FetchCourseQuery, FetchCourseQueryVariables>(
    'FetchCourse',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRoutingInfomationQuery((req, res, ctx) => {
 *   const { courseId } = req.variables;
 *   return res(
 *     ctx.data({ routingInfomation })
 *   )
 * })
 */
export const mockRoutingInfomationQuery = (resolver: ResponseResolver<GraphQLRequest<RoutingInfomationQueryVariables>, GraphQLContext<RoutingInfomationQuery>, any>) =>
  graphql.query<RoutingInfomationQuery, RoutingInfomationQueryVariables>(
    'RoutingInfomation',
    resolver
  )
